import { useHotkeys } from 'react-hotkeys-hook';

import { useOS } from '@/shared/hooks/useOS';
import { hotkeyToSymbol } from '@/shared/utils/common-utils';
import { cn, Kbd } from '@kognitos/lattice';

export interface HotkeyTriggerProps {
  /** The class name to apply to the shortcut display */
  className?: string;
  /** Callback function to execute when the hotkey is pressed */
  onHotkeyPress: () => void;
  /** The hotkey combination to listen for (e.g., 'ctrl+k', 'cmd+shift+p') */
  shortcut: string;
  /** Whether to render the helper text showing the hotkey symbols */
  renderHelperText?: boolean;
  /** Whether to disable the hotkey trigger */
  disabled?: boolean;
  /** Whether to prevent default browser behavior */
  preventDefault?: boolean;
  /** Whether to enable hotkeys when form elements have focus */
  enableOnFormTags?: boolean;
}

export const HotkeyTrigger = ({
  className,
  onHotkeyPress,
  shortcut,
  renderHelperText = true,
  disabled = false,
  preventDefault = true,
  enableOnFormTags = false,
}: HotkeyTriggerProps) => {
  const os = useOS();
  useHotkeys(shortcut, onHotkeyPress, {
    enabled: !disabled,
    preventDefault,
    enableOnFormTags,
  });

  if (!renderHelperText) {
    return null;
  }

  return (
    <Kbd className={cn('ml-auto', className)}>
      {hotkeyToSymbol(shortcut, os)}
    </Kbd>
  );
};
